<script>
  import { onInterval } from '../clockutil.js';

  var text = 'why are you here';
  var text1 = 'don\'t force yourself'
  var text2 = 'don\'t cry'
  var text3 = 'who told you about this?'
  var text4 = 'why is no one helping me'
  var text5 = 'this isn\'t right'

  var list = [text, text1, text2, text3, text4, text5]

  onInterval(() => text = list[Math.floor(Math.random() * list.length)], 100);


</script>

<style>
  h1 {
    font-family: monospace;
    font-size: 18px;
    width: 70%;
    padding-top: 100px;
  }
  p {
    font-family: monospace;
    font-size: 14px;
    width: 70%;
    margin-top: 20px;
  }
</style>

<h1>BELPHEGOR</h1>
<p>{text}</p>
